import { computed, defineComponent, ref, watch, getCurrentInstance } from "vue";
import FormPanel from "@/views/creative/components/form-panel.vue";
import { ElSchemaFormItem } from "el-schema-form";
import { AdaptRatioType, ModelEditorProtocol, ModelEditorProtocolDataType } from "@/store/creative/model-editor/index.type";
import _ from "lodash";
import ResetResource from "@/views/creative/components/reset-resource.vue";
export default defineComponent({
    components: {
        ResetResource: ResetResource,
        FormPanel: FormPanel,
        ElSchemaFormItem: ElSchemaFormItem
    },
    setup: function setup(props) {
        var postMessage = function postMessage(data) {
            store.dispatch("creative/template/previewer/postMessage", {
                target: "previewer",
                type: ModelEditorProtocol,
                data: data
            });
        };
        var handleReset = function handleReset(param) {
            var prop = param.prop, ratio = param.ratio;
            var originalData = originalAdaptData.value.find(function(item) {
                return item.ratio === ratio;
            });
            var originalValue = originalData[prop];
            handleChangeItem(ratio, {
                prop: prop,
                value: originalValue
            });
        };
        var handleChangeItem = function handleChangeItem(type, event) {
            var oldData = _.cloneDeep(adaptData.value);
            var targetIndex = oldData.findIndex(function(item) {
                return item.ratio === type;
            });
            oldData[targetIndex][event.prop] = event.value;
            store.commit("creative/modelEditor/setAdaptData", oldData);
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var activeNames = ref([]);
        var handleChange = function(value) {
            activeNames.value = value;
        };
        var adaptData = computed(function() {
            return store.state.creative.modelEditor.cameraAdaptConfig.adapt.adaptDatas;
        });
        var originalAdaptData = computed(function() {
            return store.state.creative.template.originalJson.cameraConfig.adapt.adaptDatas;
        });
        watch(function() {
            return adaptData.value;
        }, function(newVal, oldVal) {
            if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                var ratio, propertyName, value;
                newVal.forEach(function(item, index) {
                    if (item.fovOffset !== oldVal[index].fovOffset) {
                        ratio = item.ratio;
                        propertyName = "fovOffset";
                        value = item.fovOffset;
                    } else if (item.orthoHeightOffset !== oldVal[index].orthoHeightOffset) {
                        ratio = item.ratio;
                        propertyName = "orthoHeightOffset";
                        value = item.orthoHeightOffset;
                    }
                });
                postMessage({
                    type: ModelEditorProtocolDataType.cameraAdapt,
                    data: {
                        type: "update",
                        ratio: ratio,
                        propertyName: propertyName,
                        value: value
                    }
                });
            }
        }, {
            deep: true
        });
        var iphone6PortraitModel = computed(function() {
            return adaptData.value.find(function(item) {
                return item.ratio === AdaptRatioType.IPhone6_Portrait;
            });
        });
        var iphone6LandscapeModel = computed(function() {
            return adaptData.value.find(function(item) {
                return item.ratio === AdaptRatioType.IPhone6_Landscape;
            });
        });
        var model1 = computed({
            get: function() {
                var model = {};
                if (iphone6PortraitModel.value) {
                    model[AdaptRatioType.IPhone6_Portrait] = iphone6PortraitModel.value;
                }
                if (iphone6LandscapeModel.value) {
                    model[AdaptRatioType.IPhone6_Landscape] = iphone6LandscapeModel.value;
                }
                return model;
            },
            set: function(value) {
                // todo
                console.log(value);
            }
        });
        var screenList = computed(function() {
            return [
                {
                    title: root.$t("playTurbo.custom.screen.horizontal"),
                    ratio: AdaptRatioType.IPhone6_Landscape,
                    disabled: !iphone6LandscapeModel.value
                },
                {
                    title: root.$t("playTurbo.custom.screen.vertical"),
                    ratio: AdaptRatioType.IPhone6_Portrait,
                    disabled: !iphone6PortraitModel.value
                }, 
            ];
        });
        var screenConfigList = computed(function() {
            return [
                {
                    title: root.$t("playTurbo.custom.screen.fovOffset").toString(),
                    type: "fovOffset"
                },
                {
                    title: root.$t("playTurbo.custom.screen.orthoHeightOffset").toString(),
                    type: "orthoHeightOffset"
                }, 
            ];
        });
        var formItemList = computed(function() {
            return {
                fovOffset: {
                    prop: "fovOffset",
                    component: "slider",
                    field: {
                        min: -100,
                        max: 100,
                        step: 1,
                        showTooltip: false
                    }
                },
                orthoHeightOffset: {
                    prop: "orthoHeightOffset",
                    component: "slider",
                    field: {
                        min: -100,
                        max: 100,
                        step: 1,
                        showTooltip: false
                    }
                }
            };
        });
        return {
            activeNames: activeNames,
            model: model1,
            screenList: screenList,
            screenConfigList: screenConfigList,
            formItemList: formItemList,
            handleChange: handleChange,
            handleReset: handleReset,
            handleChangeItem: handleChangeItem,
            adaptData: adaptData,
            originalAdaptData: originalAdaptData
        };
    }
});
